import { useState } from "react";

export type FaqItem = {
  q: string;
  a: string;
};

type FaqAccordionProps = {
  items: FaqItem[];
  defaultOpen?: number | null;
};

export default function FaqAccordion({ items, defaultOpen = 0 }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);

  return (
    <div className="divide-y divide-background-200/80 border border-background-200/80 rounded-lg overflow-hidden bg-background-50">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <button
              type="button"
              aria-expanded={isOpen}
              onClick={() => setOpenIndex(isOpen ? null : index)}
              className="w-full flex items-start justify-between gap-4 px-4 md:px-6 py-4 md:py-5 text-left hover:bg-background-100/70 transition-colors"
            >
              <span className="flex items-start gap-3">
                <span className="shrink-0 w-6 h-6 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center text-xs font-heading font-bold">
                  Q
                </span>
                <span className="font-heading text-sm md:text-base font-semibold text-foreground-950 leading-snug">
                  {item.q}
                </span>
              </span>
              <span className="shrink-0 w-6 h-6 flex items-center justify-center text-foreground-500">
                <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
              </span>
            </button>
            {isOpen && (
              <div className="px-4 md:px-6 pb-5 pl-[52px] md:pl-[60px]">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}